import * as React from 'react';
import { useEffect } from 'react';
import FunctionsData from '../../../Functions/FunctionsData';

export default function CampaignsPostcodes({ row }) {
    const [value, setValue] = React.useState(row.postcodes || '');

    function cleanTag(d) {
        d = d.replace(/  /g,' ');
        d = d.replace(/ /g,',');
        d = d.replace(/;/g,',');
        d = d.replace(/,,/g,',');
        return d;
    }

    async function updatePostcodes() {
        const tkn = await FunctionsData.getCSRFToken();
        let requestOptionsVoucher = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'token': sessionStorage.sTkn,
                'X-CSRF-Token': tkn.csrf,
            },
            body: JSON.stringify({
                postcodes: value,
            }),
        };

        await fetch(FunctionsData.getApiUrl('/api/campaign/')+ row.id, requestOptionsVoucher)
            .then((response) => response.json())
            .then((res) => {
                //console.log("/api/voucher/update/"+id,res);
            });
    }

    return (
        <textarea
            className={'form-control'}
            style={{ minWidth: 200, marginBottom: 0 }}
            value={value}
            placeholder="Add a postal code"
            onChange={(e) => setValue(cleanTag(e.currentTarget.value))}
            rows={5}
            onBlur={updatePostcodes}
        />
    );
}
